import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type CapsuleDto } from './capsules.endpoints';

export type CapsuleEntity = CapsuleDto;

export interface CapsuleState {
  byId: string[];
  entities: Record<string, CapsuleEntity>;
}

const initialState: CapsuleState = {
  byId: [],
  entities: {},
};

export const capsuleSlice = createSlice({
  name: 'capsules',
  initialState,
  reducers: {
    setCapsules(
      state,
      action: PayloadAction<{
        byId: string[];
        entities: Record<string, CapsuleEntity>;
      }>,
    ) {
      const nextState = action.payload;
      state.byId = nextState.byId;
      state.entities = nextState.entities;
    },

    upsertCapsule(state, action: PayloadAction<CapsuleEntity>) {
      const capsule = action.payload;
      const idKey = String(capsule.id);
      if (state.entities[idKey] === undefined) {
        state.byId.push(idKey);
      }
      state.entities[idKey] = capsule;
    },

    removeCapsule(state, action: PayloadAction<string>) {
      const capsuleId = action.payload;
      state.byId = state.byId.filter((storedId) => storedId !== capsuleId);
      delete state.entities[capsuleId];
    },
  },
});

export const { setCapsules, upsertCapsule, removeCapsule } = capsuleSlice.actions;
export const capsuleReducer = capsuleSlice.reducer;
